module.exports = __webpack_public_path__ + "assets/img/29_303.db1505bc.jpg";